import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { Separator, Text } from '@cuemath/comps';
import styled from 'styled-components';

import { get as getTeacherSlot } from 'actions/teacher-slots';
import { openModal } from 'actions/modal';
import TeacherBatch from 'modules/teacher-batch-view';
import { FormWrapper } from 'modules/form';

const SlotViewHeader = styled(Text)`
  font-size: 28px;
  line-height: 0;
  position: absolute;
  top: 48px;
`;

class CreateSlot extends Component {
  static defaultProps = {
    teacher: null,
  };

  static propTypes = {
    actions: PropTypes.shape({
      getTeacherSlot: PropTypes.func.isRequired,
    }).isRequired,
    teacher: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    userConfig: PropTypes.object.isRequired,
    batchConfig: PropTypes.object.isRequired,
    programs: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    const { teacher } = this.props;

    this.state = {
      teacherSlots: null,
      teacherData: teacher,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { teacherSlots, teacher, actions } = props;

    const slotGet = store.get(teacherSlots, teacher.id) || {};
    const { data, isLoaded, isLoading, isStale } = slotGet || {};

    if (isLoaded && !isStale && data) {
      newState.teacherSlotsIsLoaded = isLoaded;
      newState.teacherSlotsIsLoading = isLoading;
      newState.teacherSlots = data;
    } else if (isLoading && !isStale) {
      newState.teacherSlotsIsLoading = isLoading;
      newState.teacherSlotsIsLoaded = isLoaded;
    } else if (slotGet && isStale) {
      actions.getTeacherSlot(teacher.id, null, { teacher_id: teacher.id });
    }

    return newState;
  }

  componentDidMount() {
    const {
      actions,
      teacher: { id },
    } = this.props;

    if (id) actions.getTeacherSlot(id, null, { teacher_id: id });
  }

  renderBatchView = () => {
    const { teacherData, teacherSlots } = this.state;

    return <TeacherBatch teacher={teacherData} uniqueSlots={teacherSlots} />;
  };

  render() {
    const { teacherSlotsIsLoading, teacherSlotsIsLoaded } = this.state;

    return (
      <FormWrapper>
        <Separator transparent height="100" />
        <SlotViewHeader>Slots Calendar</SlotViewHeader>
        {teacherSlotsIsLoading && <div>Loading...</div>}
        {teacherSlotsIsLoaded && this.renderBatchView()}
      </FormWrapper>
    );
  }
}

export default connect(
  ({ teacherSlots }) => ({ teacherSlots }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getTeacherSlot,
        openModal,
      },
      dispatch,
    ),
  }),
)(CreateSlot);
